<template>
  <teleport to="body">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4"
    >
      <div class="bg-white rounded-lg shadow-xl max-w-sm w-full animate-in">
        <!-- Header -->
        <div class="p-6 border-b border-slate-200">
          <h2 class="text-xl font-bold text-slate-900">{{ title }}</h2>
        </div>

        <!-- Body -->
        <div class="p-6">
          <p class="text-slate-600">{{ message }}</p>
        </div>

        <!-- Footer -->
        <div
          class="p-6 bg-slate-50 border-t border-slate-200 flex gap-3 justify-end rounded-b-lg"
        >
          <button
            @click="handleCancel"
            :disabled="isLoading"
            class="px-4 py-2 rounded-lg bg-slate-200 text-slate-900 font-semibold hover:bg-slate-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            Cancel
          </button>
          <button
            @click="handleConfirm"
            :disabled="isLoading"
            class="px-4 py-2 rounded-lg bg-red-600 text-white font-semibold hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors inline-flex items-center gap-2"
          >
            <span
              v-if="isLoading"
              class="inline-block animate-spin"
            >
              <svg
                class="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
            </span>
            {{ confirmText }}
          </button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
  import { defineProps, defineEmits } from "vue";

  defineProps({
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Confirm Action",
    },
    message: {
      type: String,
      default: "Are you sure?",
    },
    confirmText: {
      type: String,
      default: "Delete",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(["confirm", "cancel"]);

  const handleConfirm = () => {
    emit("confirm");
  };

  const handleCancel = () => {
    emit("cancel");
  };
</script>

<style scoped>
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .animate-in {
    animation: slideIn 0.2s ease-out;
  }
</style>
